import { createSlice } from "@reduxjs/toolkit";
import {
  getAllPlans,
  myCurrentSubscription,
  startFreeTrial
} from "store/actions/subscriptionSlice";

const initialState = {
  isLoading: false,
  mySubscriptionDetails: [],
  loading: false,
  perPage: 10,
  totalCount: null,
  totalPages: null,
  currentPage: null,
  allPlans: [],
  gettingDetails: false,
};

const branchSlice = createSlice({
  name: "subscriptions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllPlans.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllPlans.fulfilled, (state, action) => {
        state.loading = false;
        const { success } = action.payload || {};
        if (success) {
          const { data, totalCount, totalPages, currentPage } = action.payload || {};
          console.log(data);
          state.allPlans = data;

        }
      })
      .addCase(getAllPlans.rejected, (state, action) => {
        state.loading = false;
      });
    builder
      .addCase(startFreeTrial.pending, (state) => {
        state.loading = true;
      })
      .addCase(startFreeTrial.fulfilled, (state, action) => {
        state.loading = false;
        const { success } = action.payload || {};
        if (success) {
          const { data, totalCount, totalPages, currentPage } = action.payload || {};
          console.log(data);
          state.allPlans = data;

        }
      })
      .addCase(startFreeTrial.rejected, (state, action) => {
        state.loading = false;
      });
    builder
      .addCase(myCurrentSubscription.pending, (state) => {
        state.loading = true;
      })
      .addCase(myCurrentSubscription.fulfilled, (state, action) => {
        state.loading = false;
        const { success } = action.payload || {};
        if (success) {
          const { data, totalCount, totalPages, currentPage } = action.payload || {};
          state.mySubscriptionDetails = data;
          // state.allPlans = data;

        }
      })
      .addCase(myCurrentSubscription.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export default branchSlice.reducer;
